import React from "react";
import {TicTacView,TictacDivRight,TicTacView1,TictacDivFlex,TictacDivBlock
} from "../FormasTicTac";
import Nofoundpage from "../../../pages/Nofoundpage";

function TicTacSee( { lengthDimention, capture, parafh } ){
  let x = [];
  for ( let index = lengthDimention + 1; index < capture.length; index++ ){
    x.push(capture[index]);
  }
  switch ( lengthDimention ){
    case 0:
      return (
        <>
        </>
      )
    case 1:
      return (
        <>
          <TicTacView capture={capture[0]} />
          <TictacDivRight capture={capture[1]} parafh={parafh[0]} />
          <TicTacView1 capture={x} />
        </>
      );
    case 2:
      return (
        <>
          <TicTacView capture={capture[0]} />
          <TictacDivRight capture={capture[1]} parafh={parafh[0]} />
          <TictacDivFlex capture={capture[2]} parafh={parafh[1]} />
          <TicTacView1 capture={x} />
        </>
      );
    case 3:
      return (
        <>
          <TicTacView capture={capture[0]} />
          <TictacDivRight capture={capture[1]} parafh={parafh[0]} />
          <TictacDivBlock capture={capture[2]} parafh={parafh[1]} />
          <TictacDivFlex capture={capture[3]} parafh={parafh[2]} />
          <TicTacView1 capture={x} />
        </>
      );
      case 4:
      return (
        <>
          <TicTacView capture={capture[0]} />
          <TictacDivRight capture={capture[1]} parafh={parafh[0]} />
          <TictacDivBlock capture={capture[2]} parafh={parafh[1]} />
          <TictacDivFlex capture={capture[3]} parafh={parafh[2]} />
          <TictacDivFlex capture={capture[4]} parafh={parafh[3]} />
          <TicTacView1 capture={x} />
        </>
      );
      case 5:
      return (
        <>
          <TicTacView capture={capture[0]} />
          <TictacDivRight capture={capture[1]} parafh={parafh[0]} />
          <TictacDivBlock capture={capture[2]} parafh={parafh[1]} />
          <TictacDivFlex capture={capture[3]} parafh={parafh[2]} />
          <TictacDivFlex capture={capture[4]} parafh={parafh[3]} />
          <TictacDivFlex capture={capture[5]} parafh={parafh[4]} />
          <TicTacView1 capture={x} />
        </>
      );
    default:
      return <Nofoundpage />;
  }
}
export default TicTacSee;
